const BASE_API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

// Menu endpoints
export const GET_MENU_BY_ID = (menuId) => `${BASE_API_URL}/menu/${menuId}`;
export const GET_ALL_MENUS = `${BASE_API_URL}/menu/all-menus`;
export const SAVE_MENU = `${BASE_API_URL}/menu/save-menu`;
export const DELETE_MENU = `${BASE_API_URL}/menu/delete-menu`;
export const SEND_QUERY = (menuId, query) =>
  `${BASE_API_URL}/waiterai/${menuId}/send-query?query=${encodeURIComponent(
    query
  )}`;

// Restaurant endpoints
export const CREATE_RESTAURANT = `${BASE_API_URL}/restaurants/create-restaurant`;
export const GET_ALL_RESTAURANTS = `${BASE_API_URL}/restaurants/all-restaurants`;
export const GET_RESTAURANT_BY_ID = (restaurantId) =>
  `${BASE_API_URL}/restaurants/${restaurantId}`;
export const FIND_RESTAURANT = (restaurantName) =>
  `${BASE_API_URL}/restaurants/find-restaurant/${restaurantName}`;
export const LOGIN_RESTAURANT = `${BASE_API_URL}/restaurants/login`;
export const DELETE_RESTAURANT = (restaurantId) =>
  `${BASE_API_URL}/restaurants/delete-restaurant/${restaurantId}`;
export const GET_RESTAURANT_THEME = (restaurantId) =>
  `${BASE_API_URL}/restaurants/get-theme/${restaurantId}`;
export const UPDATE_RESTAURANT_THEME = (restaurantId) =>
  `${BASE_API_URL}/restaurants/update-theme/${restaurantId}`;
export const CHANGE_ACCOUNT_DETAIL = (
  detailToChange,
  restaurantId,
  newDetail
) =>
  `${BASE_API_URL}/restaurants/change-${detailToChange}/${restaurantId}/${newDetail}`;

// Model endpoints
export const CREATE_MODEL = `${BASE_API_URL}/models/create-model`;
export const GET_MODEL_BY_ID = (modelId) => `${BASE_API_URL}/models/${modelId}`;
export const GET_MODEL_BY_URL = (modelUrl) =>
  `${BASE_API_URL}/models/url/${modelUrl}`;
export const DELETE_MODEL = (modelId) =>
  `${BASE_API_URL}/models/delete-model/${modelId}`;
export const UPLOAD_MODEL = (restaurantId) =>
  `${BASE_API_URL}/models/${restaurantId}/upload-model`;

// Item endpoints
export const LIKE_ITEM = (itemId) => `${BASE_API_URL}/items/${itemId}/like`;
export const UNLIKE_ITEM = (itemId) => `${BASE_API_URL}/items/${itemId}/unlike`;
export const FETCH_ITEM_BY_MODEL = (modelUrl) =>
  `${BASE_API_URL}/items/model/${modelUrl}`;

// EmailJS configuration endpoint
export const GET_EMAILJS_CONFIG = `${BASE_API_URL}/emailjs/config`;

// Report endpoints
export const PUT_INPUT_DATA = (restaurantId) =>
  `${BASE_API_URL}/reports/${restaurantId}/import-input-data`;
export const GET_REPORT = (fileName) =>
  `${BASE_API_URL}/reports/get-report/${fileName}`;
export const GET_INPUT_FILE = (fileName) =>
  `${BASE_API_URL}/reports/get-input-file/${fileName}`;
export const GET_ALL_FILES = (restaurantId) =>
  `${BASE_API_URL}/reports/${restaurantId}/get-all-files`;

//Order endpoints
export const CREATE_ORDER = `${BASE_API_URL}/orders/create-order`;
